export type WatermarkAnchor =
  | 'top-left' | 'top-center' | 'top-right'
  | 'center-left' | 'center' | 'center-right'
  | 'bottom-left' | 'bottom-center' | 'bottom-right';

export const WATERMARK_ANCHORS: WatermarkAnchor[] = [
  'top-left', 'top-center', 'top-right',
  'center-left', 'center', 'center-right',
  'bottom-left', 'bottom-center', 'bottom-right',
];

export type WatermarkConfig = {
  imageUrl: string;
  anchor: WatermarkAnchor;
  sizePercent: number;
  opacityPercent: number;
  marginXPercent: number;
  marginYPercent: number;
};

// GraphQL shape from the EFFECTIVE_WATERMARK query (snake_case)
export type CampaignWatermarkGql = {
  image_url: string;
  anchor: WatermarkAnchor;
  size_percent: number;
  opacity_percent: number;
  margin_x_percent: number;
  margin_y_percent: number;
};

export const gqlToWatermarkConfig = (g: CampaignWatermarkGql): WatermarkConfig => ({
  imageUrl: g.image_url,
  anchor: g.anchor,
  sizePercent: g.size_percent,
  opacityPercent: g.opacity_percent,
  marginXPercent: g.margin_x_percent,
  marginYPercent: g.margin_y_percent,
});
